var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6111 3.63001C29.4987 4.1229 28.3052 4.45717 27.0512 4.6064C28.3316 3.83964 29.3118 2.62344 29.7763 1.1787C28.5752 1.88877 27.2495 2.40438 25.8368 2.68388C24.7056 1.47712 23.0966 0.725464 21.3119 0.725464C17.888 0.725464 15.1118 3.50161 15.1118 6.92364C15.1118 7.40897 15.1666 7.88299 15.2724 8.33628C10.1205 8.07751 5.55213 5.60922 2.4946 1.85855C1.96013 2.77262 1.65608 3.83771 1.65608 4.97465C1.65608 7.12571 2.75143 9.02369 4.41336 10.1341C3.39731 10.1001 2.44171 9.82062 1.60511 9.35603V9.43346C1.60511 12.4362 3.74294 14.9423 6.57761 15.5127C6.05825 15.6524 5.5106 15.7299 4.94403 15.7299C4.54368 15.7299 4.15652 15.6902 3.77692 15.6146C4.5663 18.0792 6.85524 19.8714 9.56719 19.9205C7.44635 21.5825 4.77218 22.5702 1.86763 22.5702C1.36719 22.5702 0.874249 22.5399 0.388916 22.4852C3.13297 24.2472 6.39069 25.2745 9.89203 25.2745C21.2969 25.2745 27.5309 15.8281 27.5309 7.63564L27.5102 6.83302C28.7282 5.96423 29.782 4.87267 30.6111 3.63001Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.13144e6deba6c48d6f92433b305c35cd.svg";
export { ForwardRef as ReactComponent };